module.exports = __webpack_public_path__ + "static/media/phoneapp-sidebar.2cf61cd4.png";